export default [
  {
    title: 'Rundowns',
    menuItems: [{ end: false, pathname: '/settings/templates', label: 'Templates' }],
  },
  {
    title: 'Workspace',
    menuItems: [
      { end: false, pathname: '/settings/workspace/outputs', label: 'Manage outputs' },
      { end: false, pathname: '/settings/workspace/canvases', label: 'Manage canvases' },
    ],
  },
  {
    title: 'Packages',
    menuItems: [{ end: false, pathname: '/settings/graphicpackages', label: 'Overview' }],
  },
];
